import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { IncomeToDelete } from '../../Income.meta';
import { useDeleteIncomeMutation } from '../../api/useDeleteIncomeMutation';

interface Props {
  clientId: string;
  income: IncomeToDelete;
  onClose(): void;
  onDelete(): void;
}

export const DeleteIncomeModal = ({ clientId, income, onClose, onDelete }: Props) => {
  const {
    mutateAsync: deleteIncome,
    isLoading: isDeletingIncome,
    error: deleteIncomeError,
  } = useDeleteIncomeMutation({ clientId });

  const handleDeleteIncome = async () => {
    try {
      await deleteIncome({ clientId, incomeId: income.id });

      onDelete();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'income--delete-income--modal-header' }}
    >
      <ModalHeader as="h2" id="income--delete-income--modal-header">
        Are you sure you want to delete this income?
      </ModalHeader>

      {deleteIncomeError && (
        <Alert message={deleteIncomeError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>{income.name}</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="error" isLoading={isDeletingIncome} onClick={handleDeleteIncome} ml="8">
          Delete Income
        </Button>
      </ModalFooter>
    </Modal>
  );
};
